import * as turf from '@turf/turf';

export const distanceCalculator = {
  /**
   * 2点間の距離をメートル単位で計算する
   * @param lat1 緯度1
   * @param lon1 経度1
   * @param lat2 緯度2
   * @param lon2 経度2
   * @returns 距離（メートル）
   */
  calculate(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const from = turf.point([lon1, lat1]);
    const to = turf.point([lon2, lat2]);

    // 距離を計算（単位をメートルで取得）
    const options = { units: 'meters' as turf.Units };
    const distance = turf.distance(from, to, options);

    return distance;
  },
};
